import { render, staticRenderFns } from "./LocationEditForm.vue?vue&type=template&id=5481d77c&"
import script from "./LocationEditForm.vue?vue&type=script&lang=js&"
export * from "./LocationEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports